import { Col, Row } from "antd";
import styles from "./NewGuest.module.css";
import {
  DropDown,
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../../../../components";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../../../Store/Middlewares/EventPlanningMiddleware";
import { showAlert } from "../../../../../../Store/Actions/GeneralActions";
import AutoCompleteInput from "../../../../../../components/auntoCompleteInput/AutoCompleteInput";

const NewGuest = () => {
  // const EventDetails = useSelector(state => state.EventReducer.EventDetails);
  const Types = useSelector((state) => state.GeneralReducer.GeneralTypes);
  const Group = useSelector((state) => state.EventPlanningReducer.GuestGroup);

  const { state } = useLocation();

  const EventDetails = state?.eventData;

  const ageArray = [
    { id: 1, name: "Teenage" },
    { id: 2, name: "Adult" },
  ];
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [lat, setlat] = useState(0);
  const [lng, setlng] = useState(0);
  const [firstName, setfirstName] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setphone] = useState("");
  const [age, setAge] = useState("");
  const [group, setGroup] = useState("");
  const [relation, setRelation] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      EventPlanningMiddleware.guestGroups({
        name: "",
        event_id: EventDetails?.id,
      })
    );
  }, []);

  const submit = () => {
    if (
      !firstName ||
      !lastname ||
      !age ||
      !group ||
      !relation ||
      !address ||
      !email ||
      !phone
    ) {
      dispatch(
        showAlert({
          title: "Add Guest",
          message: "All fields are mandatory!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          type:'error',
          message:
            "Please enter a valid email address in the correct format (e.g example@example.com)",
        })
      );
      return;
    } else {
      let data = {
        first_name: firstName,
        last_name: lastname,
        email: email,
        contact_no: phone,
        event_id: EventDetails?.id,
        guest_group_id: group?.id,
        relation_id: relation?.id,
        age_group: age?.val,
        address: address,
        lat,
        lng,
      };

      dispatch(EventPlanningMiddleware.createGuest(data))
        .then(() => navigate(-1))
        .catch();
    }
  };

  return (
    <>
      <Row>
        <Col>
          <TextComponent textClass={styles.headingText}>
            Guest Information
          </TextComponent>
        </Col>
      </Row>
      <Row gutter={{ xs: 0, sm: 8, lg: 16 }}>
        <Col xs={24} sm={12} lg={8}>
          <InputField
            label={"First Name"}
            placeholder={"Enter First Name"}
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <InputField
            label={"Last Name"}
            placeholder={"Enter Last Name"}
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <DropDown
            object={ageArray}
            placeholder={"Enter Age"}
            label={"Age"}
            onChange={setAge}
            // options={}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <InputField
            label={"Email"}
            placeholder={"Enter Email"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <PhoneInput
            label={"Contact Number"}
            placeholder={"Enter Contact Number"}
            value={phone}
            onChange={(e) => setphone(e)}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <AutoCompleteInput
            label={"Address"}
            placeholder={"Enter Address"}
            value={address}
            onSelectPlace={(data) => {
              setAddress(data?.formatted_address);
              setlat(data?.geometry?.location?.lat());
              setlng(data?.geometry?.location?.lng());
            }}
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <div className={styles.dropBtn}>
            <DropDown
              stylesClass={styles.groupCont}
              placeholder={"Enter Group"}
              name={"role"}
              label={"Group"}
              object={Group}
              onChange={setGroup}
            />
            <SubmitButton
              btnClass={styles.btn}
              title={"Add Group"}
              onClick={() =>
                navigate("/events/eventDetail/guests", {
                  state: { ...state, activeKey: "5", headrTitle: "Group" },
                })
              }
            />
          </div>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <DropDown
            placeholder={"Enter Relation"}
            label={"Relation"}
            object={Types?.relations}
            onChange={setRelation}
          />
        </Col>
      </Row>
      <Row className={styles.btnRow}>
        <Col xs={24} sm={12} lg={8}>
          <SubmitButton title="Add" onClick={submit} />
        </Col>
      </Row>
    </>
  );
};

export default NewGuest;
